import React, { useState } from 'react'
import { Marker, InfoWindow } from '@react-google-maps/api';
import styles from "./map.module.css";

export default function MapMarker(props) {

    const [show, setShow] = useState(false)

    const showInfo = () => {
        setShow(!show)
    }

    return (
        <div>
            <Marker position={{ lat: props.marker.latitude, lng: props.marker.longitude}} onClick={showInfo} />
            {show ? <>
                <InfoWindow onCloseClick={showInfo} position={{ lat: props.marker.latitude, lng: props.marker.longitude }} >
                    <a className={`${styles.link}`} href={`https://maps.google.com/?q=${props.marker.addressLine1}+${props.marker.postcode}`} target="_blank" rel="noreferrer">
                        <div className={`${styles.mapMarker}`}>
                            <p><b><u>{props.name}</u></b></p>
                            <p>{props.marker.addressLine1}</p>
                            <p>{props.marker.addressLine2}</p>
                            <p>{props.marker.addressLine3}</p>
                            <p>{props.marker.postcode}</p>
                        </div>
                    </a>
                </InfoWindow></> : <></>}
        </div>
    )
}
